import React from "react";
import {Col, Form, InputGroup} from "react-bootstrap";

const TextInputComponent = (props) => {

    return(
        <Form.Group as={Col} md="4">
            <Form.Label>{props.field.name}</Form.Label>
            <InputGroup >
                <Form.Control
                    type="text"
                    name={props.field.name}
                    onChange={props.formik.handleChange}
                    value={props.formik.values[`${props.field.name}`]}
                    onBlur={props.formik.handleBlur}
                    className="inputClear"
                    style={{fontSize: "13px", height:"40px", color: "#000000"}}
                />
                <Form.Control
                    onChange={props.formik.handleChange}
                    value={props.formik.values[`${props.field.name}-mr-filter-type`]}
                    as="select"
                    id={props.field.name + "-mr-filter-type"}
                    name={props.field.name + "-mr-filter-type"}
                    style={{height: "40px", width: "110px", maxWidth: "110px"}}>
                    <option selected= "selected" key={props.field.name + "-filter-type-like"} value={'TEXT_LIKE'}>Like</option>
                    <option key={props.field.name + "-filter-type-equals"} value={'TEXT_EQUALS'}>Equals</option>
                </Form.Control>
            </InputGroup>
        </Form.Group>
    );
}

export default TextInputComponent;
